import { render, staticRenderFns } from "./AlbumForm.vue?vue&type=template&id=979616f8&scoped=true"
import script from "./AlbumForm.vue?vue&type=script&lang=js"
export * from "./AlbumForm.vue?vue&type=script&lang=js"
import style0 from "./AlbumForm.vue?vue&type=style&index=0&id=979616f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979616f8",
  null
  
)

export default component.exports